import React, { useState } from "react";
import { Github, Linkedin, Mail, Phone, LocateIcon } from "lucide-react";
import "../../styles/update/contact.css";
import github from "../../assets/images/svg/github.svg";
import linkedin from "../../assets/images/svg/linkedin.svg";
import whatsapp from "../../assets/images/svg/whatsapp.svg";
import WhatsAppButton from "../../Components/WhatsAppButton";
import { Bounce, Slide, ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import supabase from "../../lib/supabase";
export default function Contact({ setContactRef }) {
  const contactRef = React.useRef(null);

  React.useEffect(() => {
    // Pass the ref up to Main
    if (setContactRef) setContactRef(contactRef);
  }, [setContactRef]);
  const [form, setForm] = useState({
    name: "",
    email: "",
    loading: false,
    message: "",
  });
  const [error, setError] = useState("");

  const addMessage = async (e) => {
    e.preventDefault();

    try {
      // Validate form before submitting
      if (!validateForm()) return;
      setForm((prev) => ({ ...prev, loading: true }));

      // Insert form data into Supabase
      const { data, error } = await supabase.from("client_messages").insert([
        {
          name: form.name.trim(),
          email: form.email.trim(),
          message: form.message.trim(),
        },
      ]);

      if (error) throw new Error(error.message);

      // Success message
      toast(
        "Thank you! Your message has been submitted. We’ll contact you shortly.",
        {
          type: "success",
          theme: "light",
        }
      );

      console.log("Inserted data:", data);

      resetForm();
    } catch (error) {
      console.error("Error adding message:", error);
      toast("Error submitting your response. Please try again.", {
        type: "error",
      });
    } finally {
      setForm((prev) => ({ ...prev, loading: false }));
    }
  };
  const validateForm = () => {
    setError("");

    // Basic field validation
    if (
      form.name.trim().length < 3 ||
      form.email.trim().length < 5 ||
      form.message.trim().length < 5
    ) {
      setError("Please fill all required fields correctly.");
      return false;
    }

    // ✅ Email validation using regex
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(form.email.trim())) {
      setError("Please provide a valid email address.");
      return false;
    }

    return true;
  };
  const resetForm = () => {
    setForm({ email: "", name: "", message: "", loading: false });
  };

  return (
    <div className="contact" ref={contactRef}>
      <div className="half-circle" />

      <div className="section">
        <h2 style={{ marginTop: 20 }} className="section-heading">
          CONTACT
        </h2>
        <div className="contact-info">
          <div className="left">
            <p>Drop Me a Message</p>
            <div>
              <p>
                Have a project or idea in mind? Feel free to drop me a text!
                Let's bring your vision to life together.
              </p>
            </div>
            <div>
              <div className="address">
                <div className="w-10 h-10 rounded-full bg-slate-800/50 backdrop-blur-sm border border-slate-700 flex items-center justify-center hover:bg-slate-700 hover:border-slate-600 transition-all duration-300 hover:scale-110">
                  <Phone className="w-5 h-5 text-slate-300" />
                </div>
                <span className="text">+923369626425</span>
              </div>
              <div className="address">
                <a
                  className="w-10 h-10 rounded-full bg-slate-800/50 backdrop-blur-sm border border-slate-700 flex items-center justify-center hover:bg-slate-700 hover:border-slate-600 transition-all duration-300 hover:scale-110"
                  href="https://mail.google.com/mail/?view=cm&to=aiengrimran@gmail.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Mail className="w-5 h-5 text-slate-300" />
                </a>
                {/* <p className="text">@gmail.com</p> */}
                <span className="text">aiengrimran@gmail.com</span>
              </div>
              <div className="address">
                <div className="w-10 h-10 rounded-full bg-slate-800/50 backdrop-blur-sm border border-slate-700 flex items-center justify-center hover:bg-slate-700 hover:border-slate-600 transition-all duration-300 hover:scale-110">
                  <span
                    className="material-icons-outlined"
                    style={{ fontSize: 20 }}
                  >
                    location_on
                  </span>
                </div>
                <span className="text">islamabad Pakistan</span>
              </div>
            </div>
          </div>
          <div className="right">
            <form onSubmit={addMessage}>
              <div className="forms">
                <div>
                  <div className="item">
                    <input
                      type="text"
                      onChange={(e) =>
                        setForm({ ...form, name: e.target.value })
                      }
                      value={form.name}
                      placeholder="Name"
                      className="general"
                    />
                  </div>
                  <div className="item">
                    <input
                      type="email"
                      placeholder="Email"
                      className="general"
                      value={form.email}
                      onChange={(e) =>
                        setForm({ ...form, email: e.target.value })
                      }
                    />
                  </div>
                  <div className="item">
                    <textarea
                      className="general"
                      type="area"
                      value={form.message}
                      placeholder="Message"
                      onChange={(e) =>
                        setForm({ ...form, message: e.target.value })
                      }
                      rows={5}
                    ></textarea>
                  </div>
                </div>

                {error && <p className="error">{error}</p>}
                <div className="item">
                  {form.loading ? (
                    <div className="loader-form "></div>
                  ) : (
                    <input
                      type="submit"
                      disabled={form.loading}
                      value={"Send"}
                      className="contact-btn"
                    />
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="footer">
          <div>
            <img
              src={require("../../assets/images/logo.png")}
              style={{
                height: 100,
              }}
              alt="logo"
            />
          </div>
          <div className="text-div">
            <p>2025 - Full Stack Developer</p>
          </div>
          <div className="icons-row">
            <div className="flex items-center justify-center gap-4 pt-4">
              <a
                target="_blank"
                href="https://api.whatsapp.com/send/?phone=923369624425&text=Hello+Imran%2C+I+found+your+portfolio+and+would+like+to+connect.&type=phone_number&app_absent=0"
                className="w-12 h-12 rounded-full bg-slate-800/50 backdrop-blur-sm border border-slate-700 flex items-center justify-center hover:bg-slate-700 hover:border-slate-600 transition-all duration-300 hover:scale-110"
              >
                <img src={whatsapp} alt="icon" style={{ height: 25 }} />
              </a>
              <a
                href="https://www.linkedin.com/in/aiengrimran"
                target="_blank"
                className="w-12 h-12 rounded-full bg-slate-800/50 backdrop-blur-sm border border-slate-700 flex items-center justify-center hover:bg-slate-700 hover:border-slate-600 transition-all duration-300 hover:scale-110"
              >
                <Linkedin className="w-5 h-5 text-slate-300" />
              </a>
              <a
                href="https://github.com/aiengrimran"
                target="_blank"
                className="w-12 h-12 rounded-full bg-slate-800/50 backdrop-blur-sm border border-slate-700 flex items-center justify-center hover:bg-slate-700 hover:border-slate-600 transition-all duration-300 hover:scale-110"
              >
                <Github className="w-5 h-5 text-slate-300" />
              </a>
            </div>
            {/*            
            <Link
              className="social-btn"
              target="_blank"
              to="https://www.linkedin.com/in/aiengrimran"
            >
              <img src={linkedin} alt="icon" style={{ height: 25 }} />
            </Link> */}
            {/* <Link
              className="social-btn"
              target="_blank"
              to="https://github.com/aiengrimran"
            >
              <img src={github} alt="icon" style={{ height: 20 }} />
            </Link> */}
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        closeOnClick={true}
        theme="dark"
        transition={Slide}
      />
    </div>
  );
}

// this portfolio app needs to support both dark and light theme support
// also add mobile responsive with hamburguer icon and when click show smooth right to left sidebar with app navigations
